module.exports = __webpack_public_path__ + "static/media/v3-logo.695879f8.svg";